import {
  ShieldAlert,
  CreditCard,
  Home,
  Plane,
  GraduationCap,
  Sunset,
  Target,
  type LucideIcon,
} from 'lucide-react'
import type { GoalType } from '@/types'
import { GOAL_TYPE_INFO } from '@/types/goals.types'
import { cn } from '@/lib/utils'

const iconMap: Record<GoalType, LucideIcon> = {
  emergency_fund: ShieldAlert,
  debt_payoff: CreditCard,
  down_payment: Home,
  vacation: Plane,
  education: GraduationCap,
  retirement_boost: Sunset,
  custom: Target,
}

interface GoalTypeIconProps {
  type: GoalType
  className?: string
  size?: 'sm' | 'md' | 'lg'
  showBackground?: boolean
}

export function GoalTypeIcon({ 
  type, 
  className, 
  size = 'md',
  showBackground = false 
}: GoalTypeIconProps) {
  const Icon = iconMap[type]
  const info = GOAL_TYPE_INFO[type]
  
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6',
  }

  const bgSizeClasses = {
    sm: 'p-1.5',
    md: 'p-2',
    lg: 'p-2.5',
  }

  if (showBackground) {
    return (
      <div className={cn(
        'rounded-full',
        bgSizeClasses[size],
        info.color.replace('text-', 'bg-').replace('-500', '-500/10'),
        className
      )}>
        <Icon className={cn(sizeClasses[size], info.color)} />
      </div>
    )
  }

  return <Icon className={cn(sizeClasses[size], info.color, className)} />
}
